export const hexadecimalGenerator = (count = 6) =>
  Array.from({ length: count }, () =>
    Math.floor(Math.random() * 16).toString(16),
  ).join('');
